import styled, { css } from 'styled-components';
import { Box, Button, IconStyled, TextFieldStyled, inputMediumStyles, Icon } from '@bechtel/gds';
import { SearchField } from '@bechtel/client-common';
import { Scalars } from '@bechtel/types';

export const SearchFieldStyled = styled(Box).attrs({
  flexBasis: { sm: '0' },
  flexGrow: { sm: '1' },
  flexShrink: { sm: '1' },
})`
  ${IconStyled} {
    right: ${({ theme }) => theme.spacings[500]};
  }
  ${TextFieldStyled} {
    ${({ theme }) => css`
      font-size: ${theme.fontSizes[400]};
      border-color: ${theme.colors.grey[300]};
      font-family: 'Graphik';
    `}
  }
`;

interface SearchCanvasButtonStyledProps {
  isDefaultFilterChange: Scalars['Boolean'];
}

export const SearchCanvasButtonStyled = styled(Button)<SearchCanvasButtonStyledProps>`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
  ${(props) =>
    props.isDefaultFilterChange &&
    css`
      background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      &:hover {
        background-color: ${({ theme }) => theme.colors.bechtel.blue[700]};
      }
    `}
`;

export const SearchFieldComponentStyled = styled(SearchField)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
`;

export const StyledIcon = styled(Icon)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    & > svg {
      height: ${({ theme }) => theme.fontSizes[500]};
    }
  }
`;
